import { render, staticRenderFns } from "./OtherUserHome.vue?vue&type=template&id=723d3560&scoped=true&"
import script from "./OtherUserHome.vue?vue&type=script&lang=js&"
export * from "./OtherUserHome.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserHome.vue?vue&type=style&index=0&id=723d3560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d3560",
  null
  
)

export default component.exports